import React from 'react';
import typeTranslations from '../../../../assets/creator/typeTranslations';
import { getTranslation } from '../../../../assets/creator/translations';

const faChevronDown = (<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="m12.002 15.948 5.656-5.666a.752.752 0 0 0 0-1.062.75.75 0 0 0-1.06 0L12 13.928 7.405 9.22a.75.75 0 0 0-1.06 0 .752.752 0 0 0 0 1.062l5.657 5.666z" fill="#767676" />
</svg>
)
const faChevronUp = (<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="m12.002 8.55 5.656 5.666a.752.752 0 0 1 0 1.062.75.75 0 0 1-1.06 0L12 10.57l-4.595 4.708a.75.75 0 0 1-1.06 0 .752.752 0 0 1 0-1.062l5.657-5.666z" fill="#767676" />
</svg>
)

export const DropdownIcon = ({ isSelected, className }) => {
    const icon = isSelected ? faChevronUp : faChevronDown;
    if(className) {
        return icon
    } else {
        return icon
    }

};

const TypeDropdownControl = ({ type, isSelected, isCheckEnabled, missingTypes, bodyListName }) => (
    <div className="element-type__control">
        <div className="element-type__name">
            {getTranslation(typeTranslations[type])}
        </div>
        <DropdownIcon isSelected={isSelected} />
    </div>
);

export default TypeDropdownControl;


// WEBPACK FOOTER //
// ./src/containers/Page/ElementSelector/TypeDropdownControl/TypeDropdownControl.js